import { getLoginAreaConfigActionComposable, getUserInfoActionComposable, instanceComposable, setTheme } from '@/composables';
import { CHANNEL_ID_KEY } from '@/constants';
import { showToast } from 'vant';

export default [
  (to, from, next) => {
    const channelId = to.query[CHANNEL_ID_KEY];
    if (channelId) {
      localStorage.setItem(CHANNEL_ID_KEY, JSON.stringify(decodeURIComponent(channelId)));
    }
    next();
  },
  (to, from, next) => {
    console.log(to);
    const { token } = to.query;
    try {
      if (token && !/null/.test(token)) {
        // 去除授权参数
        const toQuery = { ...to.query };
        delete toQuery.token;
        localStorage.setItem('token', JSON.stringify(decodeURIComponent(token || '')));
        next({ name: to.name, params: to.params, path: to.path, query: toQuery, replace: true });
      } else {
        next();
      }
    } catch (error) {
      console.error(error);
      // alert(error);
    }
  },
  async (to, from, next) => {
    console.log(new Date().getTime());
    console.log('方法');
    console.log(to);
    console.log(window.cfmoto);
    // 设置主题色
    if (to.name !== 'ticket-previewTicket' && window.cfmoto.existFunction('getSystemTheme')) {
      await setTheme(to);
    }

    // 获取与设置国家地区
    const resConfig = await getLoginAreaConfigActionComposable;
    console.log(resConfig);
    console.log(new Date().getTime());
    if (to.meta.auth !== 1) {
      next();
      return;
    }
    // 页面访问控制
    const userInfo = await getUserInfoActionComposable;
    console.log('userInfo:', userInfo);
    if (!userInfo.userId) {
      showToast(instanceComposable.getI18n().global.t('cfmoto.pleaseLoginFirst'));
      return;
    } else {
      next();
    }
  },
];
